import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

// Composants Material utilises
import { MatDialogModule } from '@angular/material/dialog';

// Composants graphiques d'Aurora
import { ConfirmationDialogComponent } from './components/confirmation-dialog.component';
import { MessageDialogComponent } from './components/message-dialog.component';

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,
		
		MatDialogModule,
	],
	providers: [
	],
	declarations: [
		ConfirmationDialogComponent,
		MessageDialogComponent,
	],
	exports: [
		ConfirmationDialogComponent,
		MessageDialogComponent,
	]
})
export class DialogsModule {
	constructor() { }
}